import client from '../../client/funDetailDataClient';
import funDetailClient from '../../client/funDetailClient';
import dictClient from '../../client/dictClient';
import picClient from '../../client/picClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    
    public async save(params: any) {
        const result = await client.save(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    public async saveBatch(params: any) {
        const result = await client.saveBatch(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByIds(params: any) {
        const result = await client.removeByIds(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByBatchId(params: any) {
        const result = await client.removeByBatchId(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    public async updateById(params: any) {
        const result = await client.updateById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    public async getById(params: any) {
        const result = await client.getById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    /** 查询图片host信息 */
    public async getPicHost(params: any) {
        const result = await picClient.getPicHost(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async selectPageData(params: any) {
        const result = await client.selectPageData(params);
        if (result) {
            return result;
        }
    }

    public async selectColumnAndDataMap(params: any) {
        const result = await client.selectColumnAndDataMap(params);
        if (result) {
            return result;
        }
    }

    

    // 查询【功能详情】分页数据
    public async selectFunDetailPageData(params: any) {
        const result = await funDetailClient.selectPageData(params);
        if (result) {
            return result;
        }
    }

    public async selectColumnMap(params: any) {
        const result = await funDetailClient.selectColumnMap(params);
        if (result) {
            return result;
        }
    }

    
    public async downloadFile(params: any) {
        await picClient.downloadFile(params);
    } 
    
    // 码表查询
    public async selectDictPageData(params: any) {
        const result = await dictClient.selectPageData(params);
        if (result) {
            return result;
        }
    }
    
    public async deleteFileByName(params: any) {
        const result = await picClient.deleteFileByName(params);
        if (result) {
            return result;
        }
    }

    public async checkFile(params: any) {
        const result = await picClient.checkFile(params);
        if (result) {
            return result;
        }
    }
    
    
}
